import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/face.jpg'


const _hoisted_1 = { class: "masthead bg-primary text-white text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container d-flex align-items-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "masthead-avatar mb-5 rounded-circle",
    src: _imports_0,
    alt: "face"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "masthead-heading text-uppercase mb-0" }, "Jan Pilař"),
  /*#__PURE__*/_createElementVNode("div", { class: "divider-custom divider-light" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "masthead-subheading font-weight-light mb-0" }, "Programmer - Web Developer"),
  /*#__PURE__*/_createElementVNode("p", { class: "masthead-subheading font-weight-light mb-0" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "mailto:pilarjan4111@gmail.com",
      class: "text-white"
    }, "pilarjan4111@gmail.com")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}